import { createContext, useState } from "react";
import { ptBR } from "../lang/ptBR";
import { countries } from "../lang/countries";
import React from 'react';

export const LangContext = createContext({})

export function LangProvider({ children }) {
    const [lang, setLang] = useState(ptBR)
    const [country, setCountry] = useState({label: 'Inglês'})

    function handleLanguage(lang) {
        countries.map(e => {
            if (e.label === lang?.label) {
                setLang(e.lang)
                setCountry(e)
            }
            return e
        })
    }

    return (
        <LangContext.Provider value={{ lang, country, handleLanguage }}>
            {children}
        </LangContext.Provider>
    )
}